import React, { Component } from 'react';
import classnames from 'classnames';

export default class ScrollTo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 'aboutRef'
        };

        this.execFunc = this.execFunc.bind(this);
    }

    execFunc(func, attr) {
        this.setState({selected: attr},
            () => func(attr));
    }

    render() {
        const {
            scrollComponents,
            aboutScrollFunc
        } = this.props;
        
        const { selected } = this.state;

        return (
            <div>
                {scrollComponents && (
                    <nav>
                        <button className={classnames(['font-accent', { 'selected': selected === 'aboutRef' }])}
                            onClick={() => this.execFunc(aboutScrollFunc, 'aboutRef')}>{i18n.t('seller_profile.nav.about')}</button>

                        {scrollComponents.map((comp) => (
                            <button key={comp.ref}
                                className={classnames(['font-accent', { 'selected': selected === comp.ref }])}
                                onClick={() => this.execFunc(comp.scrollFunc, comp.ref)}>{comp.title}</button>
                        ))}
                    </nav>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/InfoPanel/scrollTo.js